import type { DeepPartial, ChartOptions } from 'lightweight-charts'

export const darkThemeVars = {
  '--tv-bg-primary': '#131722',
  '--tv-bg-secondary': '#1e222d',
  '--tv-bg-tertiary': '#2a2e39',
  '--tv-border': '#2a2e39',
  '--tv-border-light': '#363a45',
  '--tv-text-primary': '#d1d4dc',
  '--tv-text-secondary': '#787b86',
  '--tv-text-muted': '#4c525e',
  '--tv-blue': '#2962ff',
  '--tv-green': '#26a69a',
  '--tv-red': '#ef5350',
} as const

export const darkChartTheme: DeepPartial<ChartOptions> = {
  layout: {
    background: { color: '#131722' },
    textColor: '#d1d4dc',
    fontFamily: 'Inter, system-ui, sans-serif',
    fontSize: 11,
  },
  grid: {
    vertLines: { visible: false },
    horzLines: { color: '#1e222d', style: 0 },
  },
  crosshair: {
    vertLine: {
      color: '#4c525e',
      width: 1,
      style: 3,
      labelBackgroundColor: '#2a2e39',
    },
    horzLine: {
      color: '#4c525e',
      width: 1,
      style: 3,
      labelBackgroundColor: '#2a2e39',
    },
  },
  rightPriceScale: {
    borderColor: '#2a2e39',
    textColor: '#787b86',
  },
  timeScale: {
    borderColor: '#2a2e39',
    timeVisible: true,
    secondsVisible: false,
    rightOffset: 20,
    fixRightEdge: false,
    fixLeftEdge: false,
  },
  watermark: { visible: false },
}

export const darkCandleColors = {
  upColor: '#26a69a',
  downColor: '#ef5350',
  borderUpColor: '#26a69a',
  borderDownColor: '#ef5350',
  wickUpColor: '#26a69a',
  wickDownColor: '#ef5350',
}
